/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	accountSummary(params) {
		return Ajax.get("/cashier/report/account/summary", params)
	},
	ioTypeSummary(params) {
		return Ajax.get("/cashier/report/io/summary", params)
	},
	customerSummary(params) {//jxdadd
		return Ajax.get("/cashier/report/customer/summary", params)
	},
	vendorSummary(params) {//jxdadd
		return Ajax.get("/cashier/report/vendor/summary", params)
	},
	employeeSummary(params) {//jxdadd
		return Ajax.get("/cashier/report/employee/summary", params)
	},
	projectSummary(params) {//jxdadd
		return Ajax.get("/cashier/report/project/summary", params)
	},
	departmentSummary(params) {//jxdadd
		return Ajax.get("/cashier/report/department/summary", params)
	},
	accountCheck(params) {
		return Ajax.get("/cashier/report/account/check", params)
	}
}
